module.exports = __webpack_public_path__ + "img/50counpon.011fa1d9.png";